export default __webpack_public_path__ + "static/media/metabase_logo.c65962a5.png";